import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "generator-container"
};
import { ElCol, ElForm, ElInput, ElMessage, ElRow } from 'element-plus';
import { onMounted, ref, computed } from 'vue';
import { request } from '@/manager/net_manager';
import { calculateMD5, compressImage, placeholderImage } from '@/tools/utils';
import store from "@/store"; // pre-declaration

export default {
  __name: 'FerrymanGenerator',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  emits: ['close'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const imageInput = ref(null);
    const preview = ref(null);
    const updates = ref({
      id: null,
      nickname: '',
      avatar: null,
      biography: ''
    }); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const uploadImage = () => {
      imageInput.value?.click();
    };

    const handleInputChange = event => {
      let file = event.target.files[0];

      if (file) {
        compressImage(file, 200 * 1024, compressedFile => {
          calculateMD5(compressedFile, async md5 => {
            const formData = new FormData();
            formData.append('file', file);
            formData.set('name', file.name);
            formData.set('path', 'ferryman_avatar');
            formData.set('md5', md5);
            const headers = {
              'Content-Type': 'multipart/form-data'
            };
            const response = await request('basic/upload_file/', formData, 'UPLOAD', headers); // console.log(`upload stage_image ${JSON.stringify(response)}`)

            if (response.code !== 0) {
              ElMessage.error({
                message: response.msg,
                duration: 1500
              });
            } else {
              preview.value = URL.createObjectURL(file);
              updates.value.avatar_id = response.data['file_id'].toString();
            }

            file = null;
            imageInput.value.value = null;
          });
        });
      }
    };

    const onSubmit = () => {
      if (!updates.value.id) {
        const parameters = {
          'world_outlook_id': worldOutlook.value.id,
          ...updates.value
        };
        request('ferryman/create/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            ElMessage.success({
              message: '舟子创建成功',
              duration: 1500
            });
            emits('close');
          } else {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      } else {
        let parameters = {
          'updates': updates.value
        };
        delete parameters['updates']['avatar'];

        if (parameters['updates']['avatar_id']) {
          parameters['updates']['avatar'] = parseInt(parameters['updates']['avatar_id']);
          delete parameters['updates']['avatar_id'];
        }

        request('ferryman/update/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            ElMessage.success({
              message: '舟子更新成功',
              duration: 1500
            });
            emits('close');
          } else {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          }
        });
      }
    };

    const onDelete = () => {
      request('ferryman/delete/', {
        id: props.data.id
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          ElMessage.success({
            message: '舟子删除成功',
            duration: 1500
          });
          emits('close');
        } else {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
        }
      });
    }; // lifecycle


    onMounted(() => {
      if (props.data) updates.value = props.data;
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544), _createVNode(_unref(ElForm), {
        model: updates.value,
        "label-width": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElCol), {
            span: 7
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), {
              class: "avatar-container"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_image, {
                src: preview.value ?? updates.value.avatar ?? _unref(placeholderImage),
                "zoom-rate": 1.2,
                "max-scale": 7,
                "min-scale": 0.2,
                "initial-index": 4,
                "show-progress": "",
                fit: "cover",
                onClick: uploadImage
              }, null, 8, ["src"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_unref(ElCol), {
            offset: 1,
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "舟子名称",
                "label-position": "left"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInput), {
                  modelValue: updates.value.nickname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => updates.value.nickname = $event),
                  maxlength: "12",
                  placeholder: "舟子名称",
                  type: "text",
                  clearable: "",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "简要生平",
              "label-position": "top"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElInput), {
                modelValue: updates.value.biography,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => updates.value.biography = $event),
                type: "textarea",
                clearable: "",
                "show-word-limit": "",
                round: "",
                placeholder: "一段简要生平...",
                maxlength: "256"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "justify-content": "space-between",
          "gap": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [props.data.id ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "close-generator",
            onClick: onDelete
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 删除舟子 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(props.data.id ? '提交更新' : '提交创建'), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};